export default "__VITE_ASSET__df59w0JQ__"